module.exports = "https://r.zoocdn.com/_next/static/images/favicon-2082f656dfc77eee9fb36d664bade38e.ico";